import React, { Component } from "react";
import "../../common/index.scss";
import { connect } from "react-redux";
import Slider from "react-slick";
import Cookies from "js-cookie";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Product4 } from "../../../services/script";
import history from "../../../history";
import womeneastern2 from "../../../assets/images/EASTERN FEMALE banner.png";
import menarabicImg from "../../../assets/images/menarabic22.png";
import menarabicImg2 from "../../../assets/images/12.png";
import menarabicImgWomenAccess from "../../../assets/images/Women accessories.png";
import menarabicImgMenAccess from "../../../assets/images/Men accessories.png";
import gadgetsNewImg from "../../../assets/images/gadgetnews.png";
import houseHoldGadgets from "../../../assets/images/House Hold Gadgets.png";
import banner5 from "../../../assets/images/banners/impression_banner5.png";
import banner1 from "../../../assets/images/banners/eastern_banner1.png";
import Placeholder from "../../../svg_code/placeholder";
import Service from "./../../../../src/components/products/common/service";
// CSS
import "react-toastify/dist/ReactToastify.css";

import Demoimage from "../../../assets/images/placeholderC.gif";

// Import custom components

import {
  fetchImages,
  getAllProducts,
  FetchCategByProducts,
  sendSubscriberEmail,
  removeWishlist,
  addItemToCart,
  fetchBestSeller,
} from "../../../actions";
import store from "../../../store";
import ProductItem from "./product-item";
import Collection from "./collection";
import TradnityCarousel from "./carousel";
import Collection2 from "./collection2";
import Notification from "../../../Notification";
import ScrollToTop from "../../pages/scroll_to_top";
import CategoriesImage from "./categoriesImage";
import { Product433 } from "../../../services/script";
import CustomChatbot from "../../chatbot/CustomChatbot";
import Loader from "../../../svg_code/loader";
import LoaderSpinner from "../../../components/loadingspin"
import SliderLoader from "../../../svg_code/sliderLoader";
import HeadSEO from "./headSEO";
import { Link } from "react-router-dom";
import ReviewsSection from "./ReviewsSection";
import { CategoryCirclesSkeleton } from "../../common/loaders/SkeletonLoaders";
import "./CategorySlider.css";

import Abayaat from "../../../assets/images/abyalatest.png";
import Toys from "../../../assets/images/Toys.png";

const PAGE_WRAP = {
  width: "100%",
  maxWidth: "93rem",        // 1400px → rem
  margin: "0 auto",
  padding: "0 clamp(1rem, 3.5vw, 3rem)",  // 16px → 48px in rem
  boxSizing: "border-box",
};

const V_GAP = {
  marginTop: "clamp(1.75rem, 4.5vw, 4rem)",   // 28px → 64px
  marginBottom: "clamp(1.75rem, 4.5vw, 4rem)",
};

const BANNER_TO_COLLECTION = {
  marginBottom: "clamp(1rem, 2.5vw, 2rem)",       // 16px → 32px
};

const COLLECTION_GAP = {
  marginTop: "clamp(1rem, 2.5vw, 2rem)",          // 16px → 32px
};

const BANNER_IMG = {
  width: "100%",
  maxWidth: "100%",
  display: "block",
  borderRadius: "1rem",
};

/* Luxury Category Carousel Arrows */
const CatPrevArrow = ({ onClick }) => (
  <button
    type="button"
    className="cat-slider-arrow cat-slider-prev"
    onClick={onClick}
    aria-label="Previous Category"
  >
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 18 9 12 15 6" />
    </svg>
  </button>
);

const CatNextArrow = ({ onClick }) => (
  <button
    type="button"
    className="cat-slider-arrow cat-slider-next"
    onClick={onClick}
    aria-label="Next Category"
  >
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  </button>
);

class TradnityMain extends Component {




  constructor(props) {
    super(props);
    this.counterT = 0;
    this.counterB = 0;

    this.state = {
      loadingCategory: true,
      loadingTop: true,
      apicondtionn: false,
      loadingBottom: true,
      subscribeModal: true,
      checkstatus: Cookies.get("SubscribeModal"),
      subscriberEmail: "",
      notification_token: true,
      check_notificaton: Cookies.get("Notification_token"),
      loading: true,
      carousel: "",
      productsLoading: true, // new state for products loading
    };
  }

  // API controlled loading
  setLoading = (value) => {
    this.setState({ productsLoading: value });
  };

  componentDidUpdate(prevProps, prevState) {
    // console.log("Products loading state changed:", this.state.productsLoading);
  }

  componentDidMount() {
    const paramsObj = {
      token: "true",
      currency: localStorage.getItem("changeCurrencies"),
      order: "asc",
    };
    // store.dispatch(FetchCategByProducts({ params: paramsObj }));
    store.dispatch(fetchImages());
    // setTimeout(() => {
    // this.setState({ apicondtionn: true })
    // localStorage.setItem("apiupdate", this.state.apicondtionn)
    // store.dispatch(getAllProducts(null, null, this.setLoading));
    // store.dispatch(fetchBestSeller());

    // }, 120000);
  }

  imageTopLoaded = () => {
    this.counterT += 1;
    if (this.counterT >= 1) {
      this.setState({ loadingTop: false });
    }
  };

  imageBottomLoaded = () => {
    this.counterB += 1;
    if (this.counterB >= 1) {
      this.setState({ loadingBottom: false });
    }
  };

  closeModal = () => {
    Cookies.set("SubscribeModal", true, { expires: 1 });
  };

  //

  render() {
    const {
      categories,
      user,
      appconfigs,
      getcatebyproducts,
      getallcategories,
      symbol,
    } = this.props;
    const {
      subscriberEmail,
      checkstatus,
      check_notificaton,
      loadingTop,
      loadingBottom,
    } = this.state;


    // const { productsLoading } = this.state;

    // if (productsLoading) {
    //   return (
    //     <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "70vh" }}>
    //       <SliderLoader />
    //     </div>
    //   );
    // }


    const colorCodes = localStorage.getItem("color_theme");
    const parsedColorCodes = JSON.parse(colorCodes);
    const appconfig = parsedColorCodes !== null ? parsedColorCodes : appconfigs;

    // Sort categories by position ascending (1 at the top, then 2, 3...)
    const sortedCategories =
      categories && categories.length > 0
        ? [...categories].sort(
            (a, b) => (Number(a?.position) || 0) - (Number(b?.position) || 0)
          )
        : [];



    const sendEmail = () => {
      const { subscriberEmail } = this.state;
      const obj = {
        email: subscriberEmail,
      };
      store.dispatch(sendSubscriberEmail(obj));
      this.closeModal();
    };

    const top = user.sliderBannner
      ? user.sliderBannner.filter((data) => data.title === "Banner Top")
      : [];
    const bottom = user.sliderBannner
      ? user.sliderBannner.filter((data) => data.title === "Banner Bottom")
      : [];

    /* Custom prev / next arrows */
    const PrevArrow = ({ onClick }) => (
      <button className="col-arrow col-arrow-prev" onClick={onClick}>
        &#8249;
      </button>
    );
    const NextArrow = ({ onClick }) => (
      <button className="col-arrow col-arrow-next" onClick={onClick}>
        &#8250;
      </button>
    );

    const sliderSettings = {
      ...Product4,
      prevArrow: <PrevArrow />,
      nextArrow: <NextArrow />,
    };

    const catCount = sortedCategories ? sortedCategories.length : 0;
    const categorySliderSettings = {
      infinite: catCount > 6,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      pauseOnHover: true,
      swipeToSlide: true,
      speed: 600,
      cssEase: "ease-in-out",
      arrows: true,
      dots: false,
      prevArrow: <CatPrevArrow />,
      nextArrow: <CatNextArrow />,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 1,
            infinite: catCount > 6,
          },
        },
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
            infinite: catCount > 5,
          },
        },
        {
          breakpoint: 880,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: catCount > 4,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: catCount > 3,
          },
        },
        {
          breakpoint: 420,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: catCount > 2,
          },
        },
      ],
    };

    function handleClick(e) {
      store.dispatch(removeWishlist(e));
    }
    function addItemTOCart(e) {
      document.querySelector(".loader-wrapper").style = "display: block";
      var item = { product_id: e, quantity: 1 };
      store.dispatch(addItemToCart(item));
    }

    const items = [

      /* ── 1. Main carousel ── */
      {
        ids: 1,
        id: appconfig?.slider_option,
        text:
          appconfig?.slider === 1 ? (
            /* Full-bleed responsive carousel */
            <div className="hero-carousel-container">
              <TradnityCarousel image={user} />
            </div>
          ) : null,
      },

      /* ── 3. Category icons ── */
      {
        ids: 3,
        id: appconfig?.slider_option,
        text: (
          <>
            {appconfig?.categories === 1 ? (
              <section style={{
                width: "100%",
                background: "var(--bg, #08090B)",
                padding: "clamp(1.5rem, 4vw, 3rem) 0 clamp(1rem, 3vw, 2rem)",
                marginTop: "clamp(1.75rem, 4.5vw, 4rem)",
              }}>
                {sortedCategories && sortedCategories.length !== 0 ? (
                  <div style={{ maxWidth: "93rem", margin: "0 auto", padding: "0 clamp(1rem, 3.5vw, 3rem)" }}>

                    {/* Title */}
                    <div style={{ textAlign: "center", marginBottom: "clamp(1.5rem, 3vw, 2.5rem)" }}>
                      <h2 style={{
                        color: "var(--text-primary, #FCFEFD)",
                        fontSize: "clamp(1.4rem, 3vw, 2rem)",
                        fontFamily: "'Cormorant Garamond', serif",
                        fontWeight: "600",
                        margin: "0 0 0.4rem",
                        letterSpacing: "0.01em",
                      }}>
                        Discover Your Collection
                      </h2>
                      <p style={{
                        color: "var(--text-muted, rgba(252,254,253,0.55))",
                        fontSize: "clamp(0.8rem, 1.5vw, 0.95rem)",
                        margin: 0,
                      }}>
                        Curated categories designed for every lifestyle.
                      </p>
                    </div>

                    {/* Category circles Slider */}
                    <div className="category-slider-section">
                      <Slider {...categorySliderSettings}>
                        {sortedCategories.map((m) => (
                          <div key={m.id} className="cat-circle-slide">
                            <Link
                              to={{
                                pathname: `/products/${m?.name?.replace(/\s+/g, "-")}-${m?.id}`,
                                state: { categories: m },
                              }}
                              className="cat-circle-link"
                            >
                              <div className="cat-circle-img-wrap">
                                <img
                                  loading="lazy"
                                  className="cat-circle-img"
                                  src={m?.category_icon_path}
                                  alt={m?.name}
                                  draggable={false}
                                />
                              </div>
                              <p className="cat-circle-name">{m.name}</p>
                            </Link>
                          </div>
                        ))}
                      </Slider>
                    </div>

                  </div>
                ) : (
                  <div style={{ maxWidth: "93rem", margin: "0 auto", padding: "0 clamp(1rem, 3.5vw, 3rem)" }}>
                    <div style={{ textAlign: "center", marginBottom: "clamp(1.5rem, 3vw, 2.5rem)" }}>
                      <h2 style={{
                        color: "var(--text-primary, #FCFEFD)",
                        fontSize: "clamp(1.4rem, 3vw, 2rem)",
                        fontFamily: "'Cormorant Garamond', serif",
                        fontWeight: "600",
                        margin: "0 0 0.4rem",
                        letterSpacing: "0.01em",
                      }}>
                        Discover Your Collection
                      </h2>
                      <p style={{
                        color: "var(--text-muted, rgba(252,254,253,0.55))",
                        fontSize: "clamp(0.8rem, 1.5vw, 0.95rem)",
                        margin: 0,
                      }}>
                        Curated categories designed for every lifestyle.
                      </p>
                    </div>
                    <CategoryCirclesSkeleton count={6} />
                  </div>
                )}
              </section>
            ) : null}
          </>
        ),
      },

      /* ── 4. Best Selling Products ── */
      {
        ids: 4,
        id: appconfig?.new_arrival_option,
        text:
          appconfig?.new_arrival === 1 ? (
            <div className="col-dark-section">
              <div style={{ maxWidth: "93rem", margin: "0 auto", padding: "0 clamp(1rem, 3.5vw, 3rem)" }}>
                <Collection type="new" title="Best Selling Products" subtitle="FAVOURITES" />
              </div>
            </div>
          ) : null,
      },

      /* ── Dynamic Category Collections (from descendant-categories API) ── */
      {
        ids: 6,
        id: appconfig?.featured_option,
        text: (
          <>
            {sortedCategories && sortedCategories.length > 0 &&
              sortedCategories.map((cat, index) => {
                const catUrl = `/products/${(cat?.name ? cat.name.replace(/\s+/g, "-") : "category")}-${cat.id}`;
                return (
                  <div key={cat.id || index} style={{ ...PAGE_WRAP, ...V_GAP }}>
                    {/* Category Banner Image (Dynamic from API image_url) */}
                    {cat?.image_url ? (
                      <div style={BANNER_TO_COLLECTION}>
                        <Link
                          to={{
                            pathname: catUrl,
                            state: { categories: cat },
                          }}
                        >
                          <LazyLoadImage
                            placeholder={<SliderLoader />}
                            className="imgHeightT"
                            src={cat.image_url}
                            alt={cat.name || "Banner"}
                            style={BANNER_IMG}
                            width="100%"
                          />
                        </Link>
                      </div>
                    ) : null}

                    {/* Category Products Slider (Dynamic title & categoryID) */}
                    <Collection2
                      type="isfeatured"
                      title={cat.name}
                      categoryID={cat.id}
                      categoryData={cat}
                      SeeAllProductsBtnCdn={true}
                    />
                  </div>
                );
              })}
          </>
        ),
      },

      /* ── 11. Reviews + Craft banner ── */
      {
        ids: 12,
        id: 1,
        text: <ReviewsSection />,
      },

      /* ── 12. Subscribe / Service ── */
      {
        ids: 13,
        id: appconfig?.subscribe_option,
        text: (
          <>
            {this.state.checkstatus !== true && appconfig?.subscribe === 1 ? (
              <div style={{ ...PAGE_WRAP, ...V_GAP }}>
                <Service />
              </div>
            ) : null}
          </>
        ),
      },
    ];

    // const sortedItems = items.sort((a, b) => a.ids - b.ids);
    const sortedItems = [...items].sort((a, b) => a.ids - b.ids);

    return (
      <div>
        <ScrollToTop />
        {this.state.notification_token === true &&
          this.state.check_notificaton !== "true" ? (
          <>
            <Notification />
            {this.setState({ notification_token: false })}
            {Cookies.set("Notification_token", true, { expires: 10 })}
          </>
        ) : null}
        <HeadSEO title="Home" />
        {sortedItems.map((item, index) => (
          <div key={index} style={index === 0 ? { paddingTop: "0px" } : {}}>{item.text}</div>
        ))}

        <CustomChatbot />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.images,
  categories: state.data.menu,
  appconfigs: state?.user?.config ?? "",
  getcatebyproducts: state.categoryByProducts.getcatebyproducts,
  symbol: state.data.symbol,
  getallcategories: state.data.getCategory,

});

export default connect(mapStateToProps)(TradnityMain);
